module.exports = __webpack_public_path__ + "static/media/gameCleanDesk.a91416b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/gameCleanDesk.jpg
// module id = 2349
// module chunks = 0